module.exports = __webpack_public_path__ + "c30c1395f5bfa52794b108c6bf133701.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/nbd_active.png
// module id = 284
// module chunks = 3